import { useContext, useEffect, useState } from "react";
import { AppContexts } from "../../../providers";
import { Form } from "../../../ui";
import Dialog from "../../common/Dialog";
import Markdown from "../../common/Markdown";
import SMSEmailInputbox from "../../common/sms-email-inputbox";

const HouseRules = () => {
  const { settings, set, loading, active } = useContext(
    AppContexts.SettingsContext,
  );
  const [houseRules, setHouseRules] = useState("");
  const [showOnGuestCheckIn, setShowOnGuestCheckIn] = useState(false);
  const [showOnIdVerification, setShowOnIdVerification] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    document.title = "Settings | House Rules - RueBaRue";
    const houseRulesSettings = settings?.house_rules || {};
    setHouseRules(houseRulesSettings.house_rules || "");
    setShowOnGuestCheckIn(
      houseRulesSettings.show_on_guest_check_in ?? false,
    );
    setShowOnIdVerification(
      houseRulesSettings.show_on_id_verification ?? false,
    );
    setDirty(false);
  }, [settings?.house_rules]);

  const handleSave = async (event) => {
    event.preventDefault();
    const saved = await set("house_rules", {
      house_rules: houseRules,
      show_on_guest_check_in: showOnGuestCheckIn,
      show_on_id_verification: showOnIdVerification,
    });
    if (saved) setDirty(false);
  };

  return (
    <li
      className={`setting-tab-content ${
        active === "house_rules" ? "uk-active" : ""
      }`}
    >
      <h2>House Rules</h2>
      <div className="uk-card hms-left-tabs-content-card mx-w-665">
        <Form className="uk-grid-small" data-uk-grid onSubmit={handleSave}>
          <div className="uk-width-1-1">
            <p className="hms-small-note">
              These rules will appear in the Guest Check-In and ID
              Verification flows. Use Markdown to format your House Rules, and
              click View Styles to see the available formatting options.
            </p>
            <div className="uk-margin-small-top">
              <SMSEmailInputbox
                label="Content"
                rows={12}
                value={houseRules}
                limit={false}
                macrosOrResponse={true}
                optimizeWithAI={true}
                allowUnlimitedAI={true}
                optimizationSource="house-rules"
                optimizationTrigger="icon"
                headerAction={
                  <a
                    href="https://intercom.help/ruebarueapp/en/articles/9792129-style-shortcuts"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Styles
                  </a>
                }
                onChange={(event) => {
                  setHouseRules(event.target.value);
                  setDirty(true);
                }}
              />
            </div>
          </div>

          <div className="uk-width-1-1 m-w-300">
            <div className="uk-flex uk-flex-between uk-flex-middle hms-setting-cb-border">
              <div>Show on Guest Check-In Flow</div>
              <div className="autosend-checkbox">
                <label
                  htmlFor="showHouseRulesOnGuestCheckIn"
                  className="setting-switch"
                >
                  <input
                    type="checkbox"
                    id="showHouseRulesOnGuestCheckIn"
                    checked={showOnGuestCheckIn}
                    onChange={(event) => {
                      setShowOnGuestCheckIn(event.target.checked);
                      setDirty(true);
                    }}
                  />
                  <span className="setting-slider setting-round"></span>
                </label>
              </div>
            </div>
          </div>

          <div className="uk-width-1-1 m-w-300">
            <div className="uk-flex uk-flex-between uk-flex-middle hms-setting-cb-border">
              <div>Show on ID Verification Flow</div>
              <div className="autosend-checkbox">
                <label
                  htmlFor="showHouseRulesOnIdVerification"
                  className="setting-switch"
                >
                  <input
                    type="checkbox"
                    id="showHouseRulesOnIdVerification"
                    checked={showOnIdVerification}
                    onChange={(event) => {
                      setShowOnIdVerification(event.target.checked);
                      setDirty(true);
                    }}
                  />
                  <span className="setting-slider setting-round"></span>
                </label>
              </div>
            </div>
          </div>

          <div className="uk-width-1-1 uk-margin-top">
            <div className="uk-flex uk-flex-middle">
              <button
                className="uk-button hms-btn hms-red-btn"
                type="submit"
                disabled={loading || !dirty}
              >
                {loading ? (
                  <div data-uk-spinner="ratio: 0.5;"></div>
                ) : dirty ? (
                  "Save"
                ) : (
                  "Saved"
                )}
              </button>
              <button
                className="uk-button hms-btn hms-white-btn uk-margin-small-left"
                type="button"
                data-uk-toggle="target: #house-rules-preview-modal"
                disabled={!houseRules.trim()}
              >
                Preview
              </button>
            </div>
          </div>
        </Form>

        <Dialog id="house-rules-preview-modal">
          <div className="uk-modal-dialog uk-modal-body">
            <button
              className="uk-modal-close-default"
              type="button"
              data-uk-close
              aria-label="Close"
            ></button>
            <h2 className="uk-modal-title">House Rules Preview</h2>
            <Markdown input={houseRules} />
          </div>
        </Dialog>
      </div>
    </li>
  );
};

export default HouseRules;
